import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=ade5a162&scoped=true"
import script from "./Enquiries.vue?vue&type=script&lang=js"
export * from "./Enquiries.vue?vue&type=script&lang=js"
import style0 from "./Enquiries.vue?vue&type=style&index=0&id=ade5a162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade5a162",
  null
  
)

export default component.exports